
import { CART_DEFAULT_STATUS } from "../../constants/status";
import { ITraderInfo } from "../../interface/ITrader";
import { resetAddress } from "../../reducers/address";
import { resetAddressPriceRule } from "../../reducers/addressPriceRule";
import { resetBusiness } from "../../reducers/business";
import { resetCart } from "../../reducers/cart";
import {getCartDefaultAsync, resetCartDefault, updateCartDefaultStatus } from "../../reducers/cartDefault";
import { resetCarts } from "../../reducers/carts";
import { logoutUser } from "../../reducers/common";
import { resetItem } from "../../reducers/item";
import { resetItemFilter } from "../../reducers/itemFilter";
import { resetLogout } from "../../reducers/login";
import { resetSavedCart } from "../../reducers/savedcart";
import { resetSettings } from "../../reducers/settings";
import { resetStandingOrders } from "../../reducers/standingOrder";
import { resetStandingOrderItems } from "../../reducers/standingOrderItems";
import { resetStandingOrderSummary } from "../../reducers/standingOrderSummary";
import { resetTenant } from "../../reducers/tenant";
import { resetTrader, setCurrentTrader } from "../../reducers/trader";
import { resetTraders } from "../../reducers/traders";
import { resetTranslation } from "../../reducers/translations";


export const clearOnHome = (dispatch:any) => {
    dispatch(resetTrader());
    clearCart(dispatch);
    clearSO(dispatch);
}

export const clearOnInvitation = (dispatch:any) => {
    dispatch(resetLogout());
    clearOnHome(dispatch);
    dispatch(resetTraders());
    dispatch(resetBusiness());
    dispatch(resetSettings());
}

export const clearOnLogout = (dispatch:any) => {
    dispatch(logoutUser())
    clearOnHome(dispatch);
    dispatch(resetTraders());
    dispatch(resetBusiness());
    dispatch(resetSettings());
    dispatch(resetTranslation());
    
}

export const clearTrader =(dispatch:any) =>{
    dispatch(resetCart());
    dispatch(resetCartDefault());
    dispatch(resetCarts());
    dispatch(resetItem());
    dispatch(resetSavedCart());
    dispatch(resetAddressPriceRule());
    dispatch(resetItemFilter());
    dispatch(resetAddress())
    dispatch(resetTrader())
}


export const clearCart =(dispatch:any) =>{
    dispatch(resetCart());
    dispatch(resetCartDefault());
    dispatch(resetCarts());
    dispatch(resetItem());
    dispatch(resetSavedCart());
    dispatch(resetAddressPriceRule());
    dispatch(resetAddress())
    dispatch(resetItemFilter());
}

export const clearSO =(dispatch:any) =>{
    
    dispatch(resetStandingOrderItems());
    dispatch(resetStandingOrderSummary());
    dispatch(resetStandingOrders());
}


export const clearOnPlaceOrder =(dispatch:any) =>{
    dispatch(resetCart());
    dispatch(resetCarts());
    dispatch(resetItem());
    dispatch(resetSavedCart());
    dispatch(resetAddressPriceRule());
    dispatch(resetAddress());
    dispatch(resetItemFilter());
    dispatch(updateCartDefaultStatus(CART_DEFAULT_STATUS.LOADED_AVAIL_DATE))
}

export const clearEverything = (dispatch:any) => {
    dispatch(resetTenant);
    clearOnLogout(dispatch);
    
}


export const getDefault= (dispatch:any,trader:ITraderInfo,tenantName:string,token:string) =>{
    dispatch(setCurrentTrader(trader));
    dispatch(getCartDefaultAsync({tenantName:tenantName,token:token,traderId:trader.id}))
}